import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'

export default {
    taskName: taskName.CHECK_PHOTO_CHECKIN,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.MEDICAL_PHOTO_CHECK_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.TREATMENT_FEEDBACK_WIDGET,
        },
        {
            component: processUI.TREATMENT_EXECUTION_WIDGET_CONTAINER,
        },
        {
            component: processUI.PHOTO_CHECKIN_WIDGET,
        },
        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_QUOTATION_WIDGET,
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        const messageList = []
        const gotoAlignerNumberUpper = context.gotoAlignerNumberUpper
        const gotoAlignerNumberLower = context.gotoAlignerNumberLower
        if (eventName === 'goto_aligner_step' && (!gotoAlignerNumberUpper || !gotoAlignerNumberLower)) {
            messageList.push(createValidationMessage('Please enter to which aligner the customer should change.', 'checkPhotoCheckin.goto_aligner_step'))
        }

        if (eventName === 'return_to_precheck' && processInstance.processCommentList.length === 0) {
            messageList.push(createValidationMessage('Please enter comment why you are returning to state precheck photo checkin.', 'checkPhotoCheckin.commentList'))

        }

        return messageList
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/check-photo-checkin.js